// import { useToggle } from 'hooks';
// import SubscriptionPlans from 'pages/Plan';
import { Icon, Text } from '@shopify/polaris';
import { LockIcon } from '@shopify/polaris-icons';
import { Fragment, memo, ReactNode } from 'react';
import { AccountPlan } from '@/constants/enum';
import { sortedPlansByTier } from '@/constants/plan';
import { usePlanDisplayName } from '@/hooks/usePlanDisplayName';
import CustomTooltip from '../CustomTooltip';
import { StyledUpgradeLock } from './styled';

interface UpgradeLockProps {
  usedFeature: AccountPlan;
  activator?: React.ReactElement;
  content?: ReactNode;
  actionBtn?: ReactNode;
}

const UpgradeLock = ({ usedFeature, activator, content, actionBtn }: UpgradeLockProps) => {
  //   const [isOpenModal, toggleModal] = useToggle<boolean>(false);
  const { getPlanName } = usePlanDisplayName();

  const customActivator = activator || (
    <div className="badge-activator">
      <Icon source={LockIcon} />
      <Text as="p" variant="bodySm">
        {getPlanName(usedFeature)}
      </Text>
    </div>
  );

  const getUpdatedPlan = () => {
    const index = sortedPlansByTier.indexOf(usedFeature);
    return index !== -1 ? sortedPlansByTier.slice(index + 1) : [];
  };

  const updatedPlan = getUpdatedPlan();

  return (
    <StyledUpgradeLock $usedFeature={usedFeature}>
      <CustomTooltip activator={<div>{customActivator}</div>} maxWidth="16.5rem">
        {content || (
          <span>
            This feature is only <strong>available</strong> on the paid plan. You need to <strong>upgrade</strong> to the{' '}
            <strong>{getPlanName(usedFeature)}</strong>
            {updatedPlan.length > 0 &&
              updatedPlan.map((item, index) => (
                <Fragment key={item}>
                  {index === updatedPlan.length - 1 ? ' or ' : ', '}
                  <strong>{getPlanName(item)}</strong>
                </Fragment>
              ))}{' '}
            plan to use this feature.
          </span>
        )}
        {/* <div className="mt-1">
          {actionBtn || (
            <Button fullWidth variant="primary" onClick={toggleModal}>
              Upgrade Now
            </Button>
          )}
        </div> */}
      </CustomTooltip>
      {/* <Modal open={isOpenModal} onClose={toggleModal} size="large" title="Upgrade to use this feature">
        <SubscriptionPlans isUpgradePlan={isOpenModal} usedFeature={usedFeature} />
      </Modal> */}
    </StyledUpgradeLock>
  );
};

export default memo(UpgradeLock);
